export const isPDFGenerationModeEnabled = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search)
  const pdfMode = urlParams.get('print')
  return pdfMode === 'true'
}
